import { Clickable, Col, Row, Text, UpdateItem } from 'components';
import { theme } from 'lib';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

const Background = styled.div`
  position: absolute;
  width: 100%;
  margin-left: 32px;
  height: 68px;
  background-color: ${theme.GREY_10};
  top: 76px;
  z-index: -1;
`;

const GloriousWinners = ({ data }) => {
  const [dismissed, setDismissed] = useState(false),
    { isMobile } = useSelector((state) => state.appState),
    { t } = useTranslation();

  if (!data?.length || dismissed) return null;

  return (
    <Col pos="relative" wid={isMobile ? 'calc(100vw - 32px)' : '100%'}>
      {isMobile && <Background />}

      <Row
        between
        center
        wid="100%"
        marg={isMobile ? '0 0 8px' : '0 0 16px'}
        pad={isMobile && '0 16px'}
      >
        <Text h2>{t('home.gloriousWinners')}</Text>

        <Clickable onClick={() => setDismissed(true)}>
          <Text b2 bold>
            {t('common.dismiss')}
          </Text>
        </Clickable>
      </Row>

      <Row start scrollX={isMobile} wid={isMobile && '100vw'}>
        {data.slice(0, 2).map((x, i) => (
          <Col
            noFlex
            key={i}
            marg={!i ? (!isMobile ? '0 24px 0 0' : '0 12px 0 16px') : isMobile && '0 16px 0 0'}
          >
            <UpdateItem item={x} idx={i} key={i} />
          </Col>
        ))}
      </Row>
    </Col>
  );
};

export default GloriousWinners;
